module.exports = __webpack_public_path__ + "static/media/excel-carer-with-client.bddcbd45.jpg";